import PropTypes from "prop-types"
import ColorTooltipItem from "components/charts/color-tooltip-item"
import { formatLongDate } from "helpers/formatters/dates"
import { makeCurrencyFormatter } from "helpers/formatters/numbers"
import { DATE } from "helpers/shapes"
import { RISK_TREND } from "../../shapes"

function RiskTooltip({ datum, riskTrends, gmv, gmvTitle, currency }) {
  if (datum) {
    return <div>
      <div className="header">{formatLongDate(datum.date)}</div>
      {riskTrends.map(category => <ColorTooltipItem key={category.id} index={datum.index} {...category} />)}
      <div className="spacer" />
      <ColorTooltipItem key="gmv" index={datum.index} color="#03A9F4" label={gmvTitle} formatter={makeCurrencyFormatter(currency)} data={gmv} />
    </div>
  } else {
    return null
  }
}

RiskTooltip.propTypes = {
  datum: PropTypes.shape({
    date: DATE.isRequired,
    index: PropTypes.number.isRequired,
  }),
  gmv: PropTypes.arrayOf(PropTypes.shape({
    date: DATE.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  gmvTitle: PropTypes.string.isRequired,
  riskTrends: PropTypes.arrayOf(RISK_TREND).isRequired,
  currency: PropTypes.string,
}

export default RiskTooltip
